import {getEnvelopeError, unwrapEntity, wrapRequest} from './afterschoolHelpers'
import {publicClient} from './publicClient'
import {API_URL_CATALOG, API_URL_STORE} from './urls'

const CHECKOUT_ERROR_KEYS = {
    OC_INVALID_GOOGLE_TOKEN_RESPONSE: 'checkout.verification-failed',
    OC_STRIPE_CHECKOUT_ERROR: 'checkout.stripe-unavailable',
    OC_INVALID_REQUEST_DATA: 'checkout.invalid-request',
    OC_INVALID_ORDER_REDIRECT_URL: 'checkout.invalid-request',
}

const offersList = (entity) => {
    const list = entity?.productPrices || entity?.prices || []

    return Array.isArray(list) ? list : []
}

export const getPublicProductBySku = (sku) =>
    publicClient
        .get(`${API_URL_CATALOG}product/page/v3/get`, {params: {sku}})
        .then(({data}) => unwrapEntity(data, 'Failed to load program'))
        .catch((error) => {
            throw getEnvelopeError(error)
        })

export const getPublicActualPrices = (sku) =>
    publicClient
        .get(`${API_URL_STORE}product/price/list/actual/v1/get`, {params: {sku}})
        .then(({data}) => {
            const entity = unwrapEntity(data, 'Failed to load price')

            return offersList(entity)
        })
        .catch((error) => {
            throw getEnvelopeError(error)
        })

export const getPublicActualPrice = (sku) => getPublicActualPrices(sku).then((list) => list[0] || null)

export const createAnonOrderV3 = (requestBodyDto) =>
    publicClient
        .post(`${API_URL_STORE}order/anon/v3/create`, wrapRequest(requestBodyDto))
        .then(({data}) => unwrapEntity(data, 'Failed to create order'))
        .catch((error) => {
            throw getEnvelopeError(error)
        })

export const checkoutErrorI18nKey = (error) => CHECKOUT_ERROR_KEYS[error?.code || error?.responseCode] || ''
